import { Link } from "react-router-dom";
import { useLocale } from "@/i18n/useLocale";
import { chromeFor } from "@/content/chrome";
import { usePageMeta } from "@/lib/usePageMeta";
import { pathFor } from "@/routes/manifest";

// Replaces the previous `path="*"` catch-all, which rendered the Landing page
// for ANY unmatched path. That returned a 200 with homepage content at
// /nonsense and, once locale prefixes existed, at /xx/platforms too — a
// crawler-visible duplicate of the homepage under arbitrarily many URLs.
export default function NotFoundPage(): JSX.Element {
  const locale = useLocale();
  const chrome = chromeFor(locale);

  usePageMeta({ title: chrome.notFound.title, description: chrome.notFound.description });

  return (
    <section className="section-page relative pt-header pb-20">
      <div className="container-page relative z-[2] max-w-[640px]">
        <p className="font-mono text-[11px] tracking-[0.2em] text-brand-emphasis uppercase">404</p>
        <h1 className="text-hero font-display font-bold mt-3">{chrome.notFound.heading}</h1>
        <p className="text-fg-muted text-[16px] md:text-[18px] mt-4">{chrome.notFound.body}</p>
        <Link to={pathFor("/", locale)} className="btn btn-primary mt-7 inline-flex">
          {chrome.notFound.backHome}
        </Link>
      </div>
    </section>
  );
}
